/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface LeadCommentReaction
 */
export interface LeadCommentReaction {
    /**
     * 
     */
    comment_id?: string;
    /**
     * 
     */
    user_id?: string;
    /**
     * 
     */
    reaction_type?: string;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    user?: User;
}

/**
 * Check if a given object implements the LeadCommentReaction interface.
 */
export function instanceOfLeadCommentReaction(value: object): value is LeadCommentReaction {
    return true;
}

export function LeadCommentReactionFromJSON(json: any): LeadCommentReaction {
    return LeadCommentReactionFromJSONTyped(json, false);
}

export function LeadCommentReactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadCommentReaction {
    if (json == null) {
        return json;
    }
    return {
        
        'comment_id': json['comment_id'] == null ? undefined : json['comment_id'],
        'user_id': json['user_id'] == null ? undefined : json['user_id'],
        'reaction_type': json['reaction_type'] == null ? undefined : json['reaction_type'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'user': json['user'] == null ? undefined : UserFromJSON(json['user']),
    };
}

export function LeadCommentReactionToJSON(json: any): LeadCommentReaction {
    return LeadCommentReactionToJSONTyped(json, false);
}

export function LeadCommentReactionToJSONTyped(value?: LeadCommentReaction | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'comment_id': value['comment_id'],
        'user_id': value['user_id'],
        'reaction_type': value['reaction_type'],
        'createdAt': value['createdAt'],
        'user': UserToJSON(value['user']),
    };
}

